module.exports = __webpack_public_path__ + "img/btn-des-arrow-up.4327b44a.png";